module.exports = __webpack_public_path__ + "static/media/AI-ML-Development.ed6334b4.png";